export default {
  BOC_ADMIN: "ROLE_WBC-BOC-ADMIN",
  BOC_VIEWER: "ROLE_WBC-BOC-VIEWER",
  FED_TEAM_ADMIN: "ROLE_WBC-FED-TEAM-ADMIN",
  FED_TEAM_USER: "ROLE_WBC-FED-TEAM-USER"
};
